module.exports = __webpack_public_path__ + "img/white-question.f92a1e74.svg";